@use "./variables.scss" as *; // 改这里
// 导出变量
:export {
  namespace: $namespace;
  elNamespace: $elNamespace;
}
